import { render } from "./DiscoverArtists.vue?vue&type=template&id=5bd1d642&scoped=true"
import script from "./DiscoverArtists.vue?vue&type=script&lang=js"
export * from "./DiscoverArtists.vue?vue&type=script&lang=js"

import "./DiscoverArtists.vue?vue&type=style&index=0&id=5bd1d642&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd1d642"]])

export default __exports__